import React, { Suspense } from 'react';
import { Row, Col, Spin, message, Layout, Icon, Modal, Input, Tooltip } from 'antd';
import { connect } from 'react-redux';
import request from '../../scripts/request'
import '../../scripts/config'
import HeaderRight from '../../components/header/header'
import InitPage from '../../components/sjzdInit/sjzdInt'
import 'antd/dist/antd.css';
import '../../assets/css/style.css';
import './index.css';
const { Header, Footer, Content } = Layout;
let store, $this;
class HomePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = { mkList: [], visible: false, zcm: '' };
        $this = this;
        store = this.props.store;

        //首页字典校验
        this.props.emitHandler('DictionariesInit', { pageName: 'homePage', init: true });
    }

    //组件载入完成
    componentDidMount() {
        setTimeout(() => {
            this.setState({ visible: !this.props.store.Dictionaries.homePageSuccess });
        }, 1500);
        this.loginMsgCheck();
        this.props.onRef(this);
        
    }
    loginMsgCheck = () => {
        const { homePageDispatch } = this.props;
        if (store != undefined) {
            request({
                url: 'api/Login/HomePageLoad',
                method: 'post',
                data: { dwid: store.objUser.dwid, yhid: store.objUser.yhid }
            }, { msg: '正在加载功能菜单，请稍等...', loading: true }).then(function (res) {
                if (res != null) {
                    //store存储
                    homePageDispatch({ type: 'homePage', data: res.data });//更新操作员数据

                }
            });
        }
        else {
            message.error('非法用户信息,请重新登录', 3, function () {
                this.props.emitHandler('reLogin', {});
            });
        }
    }
    //点击
    bottonClickHandler = (e, obj) => {
        const { homePageDispatch } = this.props;
        if (obj.disabled === 'True') {
            message.warning('无权进行操作该业务模块，请联系管理员分配相关业务功能!');
        }
        else if (obj.children.length < 1) {
            message.info('当前科室没有开通该模块,请开在系统管理->用户管理->科室权限分配开通');
        }
        else {
            //更新pageName
            localStorage.setItem('objPage', JSON.stringify({ pageName: 'index', mkmc: obj.title, mkid: obj.key, Menu: obj.children }))
            homePageDispatch({ type: 'topContainer', data: { pageName: 'index', mkmc: obj.title, mkid: obj.key, Menu: obj.children } });//更新页面状态

        }
    }
    //生成模块清单
    mkHandler(data) {
        if (data.length > 0) {
            return (
                data.map((obj, index) => {
                    return (
                        <Col span={parseInt(obj.span)} onClick={e => this.bottonClickHandler(e, obj)}>
                            <Tooltip title={obj.disabled === 'True' ? '无权进行操作' : obj.title}><div className={obj.disabled === 'True' ? 'gutter-box-disabled' : 'gutter-box'} data-name={obj.key}><Icon type={obj.img}></Icon>{obj.title}</div></Tooltip>
                        </Col>
                    )
                })
            )
        }
    }
    //字典初始化

    inithandleCancel() {
        if (!store.Dictionaries.homePageSuccess) {
            message.warning('公共字典初始化尚未完成,请勿关闭窗口');
        }
        else {
            $this.setState({ visible: false });
        }
    }
    //用户注册
    regClick = () => {
        Modal.confirm({
            title: '序列号注册',
            width: 400,
            maskClosable: true,
            content: (
                <Input style={{ width: '300px' }} placeholder="请输入注册码" onChange={e => this.setState({ zcm: e.target.value })}></Input>
            ),
            cancelText: '自主注册',
            cancelButtonProps: { type: 'danger', icon: 'file-done' },
            okButtonProps: { icon: 'file-protect' },
            okText: '注册码注册',
            onOk() {
                if ($this.state.zcm !== '') {
                    $this.regSubmit({ type: 'zcmzc', zcm: $this.state.zcm });
                }
            },
            onCancel() {
                $this.regSubmit({ type: 'zzzc' });
            }
        });
    }
    regSubmit = parame => {
        const { store } = this.props;
        request({
            url: 'api/Index/userReg',
            method: 'post',
            data: parame
        }, { msg: '注册信息提交中,请稍等', loading: true }).then(function (res) {
            if (res != null) {
                $this.loginMsgCheck();
            }
        });
    }
    //操作员科室选择
    ksOnChange = (value) => {
        //更新stroe的操作员信息
        const { homePageDispatch, store } = this.props;
        if (value !== store.objUser.czy_ksid) {
            const user = store.objUser;
            const objCzy = Object.assign({}, user, { czy_ksid: value, ksid: value });
            localStorage.setItem('userStorage', JSON.stringify(objCzy))//操作员数据本地存储

            homePageDispatch({ type: 'objUser', data: objCzy });
            //更新菜单
            setTimeout(() => {
                this.loginMsgCheck();
            }, 50);
        }
    }
    ParentTodo = (param) => {
        if (param != null && param != undefined) {
            if (param.lx === 'DictionariesUpdate') {
                $this.setState({ visible: true });
            }
        }
    }
    render() {
        return (
            <Suspense fallback={<Spin size="large" />}>
                <div className='homepage-container'>
                    <Layout className="homepage-container-layout">
                        <Header className="homepage-header">
                            <div>
                                <div className="logo" >
                                    <a><img src={global.constants.logo} alt="logo" /><h1>{global.constants.yynam}</h1></a>
                                </div>
                                <HeaderRight ksOnChange={this.ksOnChange} emitHandler={this.props.emitHandler} ParentTodo={this.ParentTodo}></HeaderRight>
                            </div>

                        </Header>
                        <Content>
                            <div className="homepage-menu">
                                <Row gutter={24}>
                                    {this.mkHandler(this.props.store.homePage.mkMenu)}
                                </Row>
                            </div>
                        </Content>
                        <Footer className="homepage-footer">
                            <Row gutter={2}>
                                <Col span={14} className='homepage-footer-usermsg'>
                                    <span>单位名称：{this.props.store.objUser.dwmc}</span>
                                    <span>行政级别：{this.props.store.objUser.xzjbmc}</span>
                                </Col>
                                <Col span={10} className='homepage-footer-usermsg' style={{ textAlign: "right" }}>
                                    <span style={{ color: this.props.store.homePage.footerMenu.color }}>到期时间：{this.props.store.homePage.footerMenu.zzrq}</span>
                                    <span style={{ color: this.props.store.homePage.footerMenu.color }}>剩余：{this.props.store.homePage.footerMenu.zzrqDay}天</span>
                                    <a className="shake" href="javascript:void(0);" title="点击自主注册" onClick={() => this.regClick()}><Icon type="caret-right"></Icon>注册</a>
                                </Col>
                            </Row>
                        </Footer>
                    </Layout>
                    {/****通用字典初始化弹窗****/}
                    <Modal
                        title={<div><Icon type="setting"></Icon>&nbsp;&nbsp;公用字典初始化</div>}
                        closable={false}
                        visible={this.state.visible}
                        okText='初始化'
                        cancelText='关闭'
                        onCancel={this.inithandleCancel}
                        confirmLoading={true}
                        destroyOnClose={true}
                    >
                        <InitPage onCancel={this.inithandleCancel} defaultdata={{ initType: 'HomePage' }}></InitPage>
                    </Modal>
                </div>
            </Suspense>
        );
    }
}
//需要渲染什么数据

function mapStateToProps(state) {
    return {
        store: state
    }
}
//需要触发什么行为

function mapDispatchToProps(dispatch) {
    return {
        homePageDispatch: (par) => dispatch(
            {
                type: par.type, data: par.data
            }
        )
    }
}
//连接组件
HomePage = connect(mapStateToProps, mapDispatchToProps)(HomePage)
export default HomePage;